/* global displayAlertNotification */
const SignUpForm = require('../component/signUpForm');


/**
 * Talent - Edit Profile Form
 */
class SingleSignup {
    /**
     * SingleSignup
     * @param form
     * @return {*}
     */
    constructor() {
        this.form = new SignUpForm();
        return;
    }
}

new SingleSignup();
